import { createStyles, makeStyles } from '@material-ui/styles';
import themes from 'styles/themes';

export const useStyles = makeStyles(() =>
    createStyles({
        searchBox: {
            position: 'absolute',
            paddingTop: 5,
            width: '100%',
            backgroundColor: '#F2F2F2',
            zIndex: 1,
        },
        searchWrap: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            padding: '0 24px',
            margin: '15px 0px',
            boxSizing: 'border-box',
        },

        searchIcon: {
            position: 'absolute',
            left: 10,
            top: 2,
            color: themes.palette.primary.main,
        },

        input: {
            padding: '3px 0 3px 30px',
            background: 'transparent',
            border: 'none',
            borderBottom: `1px solid ${themes.palette.grey['300']}`,
            color: themes.palette.primary.main,
            fontSize: 14,
            position: 'relative',
            borderRadius: 0,
            outline: 'none !important',
        },
        styleListItems: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
            overflowY: 'scroll',
        },
        styleListItem: {
            display: 'flex',
            // flexWrap: 'wrap',
            width: '95vw',
            maxWidth: 1000,
            padding: '20px 5px',
            borderBottom: '1px solid #D1D1D1',
        },
        styleListItemLeft: {
            '& img': {
                width: 56,
                height: 56,
                borderRadius: 6,
                objectFit: 'cover',
                objectPosition: 'center top',
            },
        },
        styleListItemRight: {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            justifyContent: 'space-between',
            padding: '0 10px',
            '& button': {
                border: '1px solid black',
                borderRadius: 71,
                background: 'none',
                textTransform: 'uppercase',
                fontSize: 14,
                padding: '5px 10px',
                color: 'black',
            },
        },
        styleListItemRightContent: {
            '& h3': {
                fontSize: 16,
            },
        },
        styleListItemBadge: {
            backgroundColor: '#F5DFCE',
            fontSize: 10,
            fontWeight: 500,
            padding: '2px 5px',
            borderRadius: 5,
            width: 'fit-content',
        },
        overLayLoadingContainer: {
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: '50%',
            left: '50%',
        },
        noSuggestions: {
            color: '#000000',
            width: '100%',
            textAlign: 'center',
            marginTop: 100,
        },
        filter: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingBottom: 10,
            paddingTop: 42,
        },
        filterSwiperWrapper: {
            display: 'flex',
            flex: 1,
            width: '100%',
            maxWidth: 1024,
            overflowX: 'auto',
            justifyContent: 'center',
            position: 'fixed',
            marginTop: 30,
            backgroundColor: '#F2F2F2',
            padding: 8,
            zIndex: 1,
        },
        firstFilterChipWrap: {
            paddingLeft: 0,
            paddingRight: '6px',
            flex: 1,
            '& .MuiChip-root': {
                width: '100%',
            },
        },
        filterChipWrap: {
            paddingLeft: '6px',
            paddingRight: '6px',
            flex: 1,
            '& .MuiChip-root': {
                width: '100%',
            },
        },
        chipActive: {
            backgroundColor: themes.palette.primary.main,
            '&.MuiChip-clickable.MuiChip-outlined:hover': {
                backgroundColor: `${themes.palette.primary.main} !important`,
            },
            '&.MuiChip-clickable.MuiChip-outlined:focus': {
                backgroundColor: `${themes.palette.primary.main} !important`,
            },
        },
        chipOutline: {
            border: '1px solid #4A6C72',
            margin: '0px 3px',
            maxWidth: '280px',
            width: '100%',
        },
        chipFilterOutline: {
            border: '1px solid #4A6C72',
            height: 32,
            width: 32,
        },
        chipLabel: {
            padding: '0 8px',
            color: themes.palette.primary.main,
            fontFamily: 'PoppinsRegular',
            fontSize: 12,
            fontWeight: 600,
        },
        chipFilterLabel: {
            display: 'none',
        },
        chipLabelActive: {
            padding: '0 8px',
            color: `${themes.palette.common.white}`,
            fontFamily: 'PoppinsRegular',
            fontSize: 12,
            fontWeight: 600,
        },
        noStyleItems: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
        },
    }),
);
